module.exports = __webpack_public_path__ + "static/media/lse.7451e738.png";